module.exports = __webpack_public_path__ + "media/dm-download.0718ab01.svg";